import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { Row, Space, Button } from 'antd';
import useMountEffect from '@restart/hooks/useMountEffect';
import commaNumber from 'comma-number';
import dayjs from 'dayjs';

import { downloadExcelFile } from 'utils/FileDownloader';
import { getUserRole } from 'utils/CodeMapper';
import { getDisplayName } from 'utils/getDisplayName';
import API from 'helpers/API';
import { UnitTable } from 'components/ui';

import styles from './index.module.scss';
import {
  buildUserColumns,
  formatUserCustomerName,
  formatUserEmail,
  USER_TABLE_SCROLL_X,
} from './userTable';

const cx = classNames.bind(styles);

const Page = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState();

  useMountEffect(() => {
    // API: 유저 내역 조회
    API.get('/users').then(({ success, data }) => {
      if (success) {
        setUsers(data.users);
      }
    });
  });

  const moveToForm = () => {
    navigate('/users/new');
  };

  const download = () => {
    const records = users.map((user) => {
      return {
        A: user.id,
        B: user.name,
        C: getUserRole(user.role),
        D: formatUserCustomerName(user),
        E: formatUserEmail(user.email),
        F: dayjs(user.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        G: getDisplayName(user.createdBy),
        H: dayjs(user.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
        I: getDisplayName(user.updatedBy),
      };
    });

    downloadExcelFile(
      [
        {
          A: '아이디',
          B: '성명',
          C: '역할',
          D: '고객사',
          E: '이메일',
          F: '등록일시',
          G: '등록자',
          H: '수정일시',
          I: '수정자',
        },
      ],
      records,
      `사용자내역-${dayjs().format('YYYYMMDDHHmmss')}`,
    );
  };

  return (
    <div className={cx('container')}>
      <h1 className={cx('title')}>사용자 내역</h1>
      <Row align="middle" justify={'space-between'} className={cx('controlbar')}>
        <div className={cx('total')}>{users && `총 ${commaNumber(users.length)}`}건</div>
        <Space>
          <Button type="primary" onClick={download}>
            엑셀 다운로드
          </Button>
          <Button type="primary" onClick={moveToForm}>
            신규
          </Button>
        </Space>
      </Row>
      <UnitTable
        columns={buildUserColumns()}
        dataSource={users}
        rowKey={(record) => record.rid}
        virtual={false}
        sticky={true}
        scroll={{ x: USER_TABLE_SCROLL_X }}
        onRow={(record) => ({ onClick: () => navigate(`/users/${record.rid}`) })}
      />
    </div>
  );
};

export default Page;
